var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfileBonus = function SvgProfileBonus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 19,
    viewBox: "0 0 512 512",
    width: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m451.75 180.75h-98.526c5.172-8.881 8.151-19.19 8.151-30.188 0-33.188-27-60.188-60.188-60.188-17.989 0-34.149 7.943-45.188 20.495-11.039-12.552-27.198-20.495-45.188-20.495-33.188 0-60.188 27-60.188 60.188 0 10.997 2.979 21.306 8.151 30.188h-98.524v90.25h30.125v241h331.25v-241h30.125zm-150.562-60.375c16.646 0 30.188 13.542 30.188 30.188s-13.542 30.188-30.188 30.188h-.062-30.126v-30.188c0-16.646 13.542-30.188 30.188-30.188zm-30.063 120.625h-30.25v-30.25h.125 30 .125zm-90.5-90.438c0-16.646 13.542-30.188 30.188-30.188s30.187 13.543 30.187 30.188v30.188h-30.125-.062c-16.646 0-30.188-13.542-30.188-30.188zm-90.375 90.438v-30.25h120.562.062v30.25h-120.5zm30.125 241v-211h90.5v211zm120.5 0v-211h30.25v211zm150.75 0h-90.5v-211h90.5zm30.125-241h-.125-120.5v-30.25h.062 120.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.221 21.622h30v50.25h-30z",
    transform: "matrix(.877 -.48 .48 .877 -1.92 85.985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.654 31.747h50.25v30h-50.25z",
    transform: "matrix(.48 -.877 .877 .48 138.302 326.792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 0h30v37.125h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.217 73.106h37.125v30h-37.125z",
    transform: "matrix(.707 -.707 .707 .707 62.115 326.171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.993 69.544h30v37.125h-30z",
    transform: "matrix(.707 -.707 .707 .707 -36.235 88.733)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileBonus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-bonus.81707ed7.svg";
export { ForwardRef as ReactComponent };